import { Alert, Button, Descriptions, Form, Select, Space } from "antd";
import { CustomTimePicker } from "components/common/custom-time-picker/custom-time-picker";
import { Timezones } from "components/pages/reports/components/scheduled-reports/timezones";
import { cloneDeep, get } from "lodash";

export const OfflineHoursConfigFormInner = ({
  basePath,
}: {
  basePath: string[];
}) => {
  return (
    <>
      <Form.Item
        name={[...basePath, "timezone"]}
        label="Timezone"
        rules={[{ required: true, message: "Please select a timezone" }]}
      >
        <Select
          style={{ minWidth: 150 }}
          showSearch
          placeholder="Select Timezone"
        >
          {Timezones.map((item) => (
            <Select.Option value={item} key={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Descriptions bordered layout="horizontal" column={1}>
        {[
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ]
          // Object.entries(
          //   widget?.configurations.workingHours?.offlineHours ||
          //     {}
          // )
          .map((day) => (
            <Descriptions.Item label={day} key={day}>
              <Space>
                <Form.Item
                  shouldUpdate
                  label="Start Time"
                  name={[...basePath, "dayWiseConfig", day, "startTime"]}
                  rules={
                    [
                      // {
                      //   required: true,
                      //   message: "Please select a start time",
                      // },
                    ]
                  }
                  // initialValue={day[1].startTime}
                >
                  <CustomTimePicker style={{ minWidth: 250 }} />
                </Form.Item>
                <Form.Item
                  shouldUpdate
                  label="End Time"
                  name={[...basePath, "dayWiseConfig", day, "endTime"]}
                  rules={
                    [
                      // {
                      //   required: true,
                      //   message: "Please select a start time",
                      // },
                    ]
                  }
                  //initialValue={day[1].endTime}
                >
                  <CustomTimePicker style={{ minWidth: 250 }} />
                </Form.Item>
                <CopyToOtherDate day={day} basePath={basePath} />
              </Space>
            </Descriptions.Item>
          ))}
      </Descriptions>

      <Alert
        type="info"
        showIcon
        className="my-2"
        message={
          "If your operations are closed on a specific day, you can simply set the start time and end time to be the same."
        }
      />
    </>
  );
};

const CopyToOtherDate = ({
  day,
  basePath,
}: {
  day: string;
  basePath: string[];
}) => {
  const form = Form.useFormInstance();

  return (
    <Button
      icon={<i className="ri-file-copy-line"></i>}
      type="text"
      onClick={() => {
        const formValue = form.getFieldsValue();
        const offlineHours = get(formValue, [...basePath, "dayWiseConfig"]);
        const dayConfig = offlineHours[day] || {};

        const newDayWiseConfig = {
          Monday: cloneDeep(dayConfig),
          Tuesday: cloneDeep(dayConfig),
          Wednesday: cloneDeep(dayConfig),
          Thursday: cloneDeep(dayConfig),
          Friday: cloneDeep(dayConfig),
          Saturday: cloneDeep(dayConfig),
          Sunday: cloneDeep(dayConfig),
        };

        form.setFieldValue([...basePath, "dayWiseConfig"], newDayWiseConfig);
      }}
    >
      Copy to all
    </Button>
  );
};
